module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAwAAAAMCAYAAABWdVznAAAAAXNSR0IArs4c6QAAANJJREFUKBWNkDEKwkAURLMbb6KeIYVHCAipLSwU0tlb2mgTxDaNjeABxJzBzgsIFtYeQAhkfROMJILGgcn/+//MbBKTpunR87wQ/oPMovpXrMBQhjZcEIygqtdqMMac4jjeq8pg+AanpgVK70tTv6EgZc3srsUHSrFmlaGw1k4532AEZVLAjLqAb5QGFlfn3ABu2CQwImBM7cIHnMMSpQFhD05es4Ca+L5/Zqa/syJQOGhfvZL6OoI8z7eIdhpiXMKh+o4eXxAg0m0N6IasMfl9yJ4CcDzNyWkQ9AAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/login/piccode.png
// module id = 444
// module chunks = 0